import { useTranslation } from 'react-i18next';
import { Download, Trash2 } from 'lucide-react';

import ReportActionButton from 'components/ReportActionButton';
import SocialShare from 'components/SocialShare';

interface ReportActionProps {
  content: string;
  disabled: boolean;
  isDownloading: boolean;
  isDeleting: boolean;
  onDownload: () => void;
  onDelete: () => void;
}

export default function ReportActions({
  disabled,
  isDownloading,
  isDeleting,
  content,
  onDownload,
  onDelete,
}: ReportActionProps) {
  const { t } = useTranslation();

  return (
    <div className='flex items-center justify-center my-2 gap-x-2 sm:justify-end'>
      <SocialShare
        content={content}
        isLoading={isDownloading}
        disabled={disabled}
      />
      <ReportActionButton
        icon={Download}
        text={t('download')}
        onClick={onDownload}
        isLoading={isDownloading}
        disabled={disabled}
      />
      <ReportActionButton
        icon={Trash2}
        text={t('delete')}
        onClick={onDelete}
        isLoading={isDeleting}
        className='text-red-500 border-red-500 hover:bg-red-500/10 hover:text-red-500'
      />
    </div>
  );
}
